import React, { useEffect, useState } from 'react';
import HeadingArea from '../../general/HeadingArea';
import { useLocation, useNavigate } from 'react-router-dom';
import ResponseMsg2 from '../../general/ResponseMsg2';
import { FaCheck } from 'react-icons/fa';
import { Bs1CircleFill, Bs2CircleFill } from 'react-icons/bs';

const EditEmployee = ({ setLoading }) => {
    const { state } = useLocation();
    const navigate = useNavigate();

    const [response2, setResponse2] = useState({ message: '', status: 'success' });

    const [formData, setFormData] = useState({
        id: '',
        name: '',
        designation: '',
        dob: '',
        doj: '',
        gender: '',
        father: '',
        mother: '',
        address: '',
        blood_grp: '',
        mobile: '',
        email: '',
        salary: '',
        profile_pic: null,
        role: '',
        user_id: '',
        pass: ''
    });

    // Prefill the form when the component mounts
    useEffect(() => {
        if (state?.employee) {
            const { profile_pic, ...rest } = state.employee;
            setFormData(prev => ({ ...prev, ...rest }));
        }
    }, [state]);

    const handleChange = (e) => {
        const { name, value, files } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: files ? files[0] : value
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);

        try {
            const data = new FormData();
            for (const key in formData) {
                if (formData[key] !== null) {
                    data.append(key, formData[key]);
                }
            }

            const response = await fetch(`https://api.kcian.in/edit-employee/${formData.id}`, {
                method: 'PUT',
                body: data
            });

            if (!response.ok) {
                setResponse2({ message: 'Something went wrong. Please try again.', status: 'error' });
                throw new Error('Failed to update employee');
            }

            const result = await response.json();
            setResponse2({ message: result.message || 'Employee Details updated successfully', status: 'success' });

            setTimeout(() => navigate('/admin/all-employees'), 2000);
        } catch (error) {
            console.error('Error:', error);
        } finally {
            setLoading(false);
            setTimeout(() => setResponse2({ message: '', status: '' }), 3000);
        }
    };

    return (
        <section className='py-4'>
            <div className='px-4'>
                <HeadingArea message1='Employee' message2='Edit Staff' />

                <p className='text-center profile-heading'>Edit Employee Details</p>

                <form onSubmit={handleSubmit}>
                    <div className='row'>

                        <div className='mb-3 col-md-4'>
                                                        <div className='profile-input-area bg-white'>
                            <label className='profile-badge'>Profile Picture</label>
                            {state?.employee?.profile_pic && (
                                <img src={`https://api.kcian.in/inUploads/${state.employee.profile_pic}`} alt='Old Pic' width='80' />
                            )}
                            <input type='file' name='profile_pic' onChange={handleChange} className='profile-input' />
                            </div>
                        </div>

                        <p className='fw-semibold border-bottom mb-5'><Bs1CircleFill /> Basic Information</p>

                        {/* Name */}
                        <div className='mb-4 col-md-4'>
                            <div className='profile-input-area'>
                                <label className='profile-badge'>Full Name*</label>
                                <input type='text' name='name' value={formData.name} onChange={handleChange} className='profile-input' required />
                            </div>
                        </div>


            {/* Designation */}
            <div className='mb-4 col-md-4'>
              <div className='profile-input-area'>
                <label className='profile-badge'>Designation*</label>
                <input type='text' name='designation' value={formData.designation} onChange={handleChange} className='profile-input' required />
              </div>
            </div>

            {/* Role */}
            <div className='mb-4 col-md-4'>
              <div className='profile-input-area'>
                <label className='profile-badge'>Role*</label>
                <select name='role' value={formData.role} onChange={handleChange} className='profile-input' required>
                  <option value=''>Select Role</option>
                  <option value='Teacher'>Teacher</option>
                    <option value="Librarian">Librarian</option>
                    <option value="Hostel">Hostel</option>
                    <option value="Transport">Transport</option>
                    <option value="Other">Other</option>                   </select>
              </div>
            </div>


            {/* DOJ */}
            <div className='mb-4 col-md-4'>
              <div className='profile-input-area'>
                <label className='profile-badge'>Date of Joining</label>
                <input type='date' name='doj' value={formData.doj} onChange={handleChange} className='profile-input' />
              </div>
            </div>


            {/* Salary */}
            <div className='mb-4 col-md-4'>
              <div className='profile-input-area'>
                <label className='profile-badge'>Salary*</label>
                <input type='number' name='salary' value={formData.salary} onChange={handleChange} className='profile-input' required />
              </div>
            </div>


           {/* Mobile */}
            <div className='mb-4 col-md-4'>
              <div className='profile-input-area'>
                <label className='profile-badge'>Mobile Number*</label>
                <input type='tel' name='mobile' value={formData.mobile} onChange={handleChange} className='profile-input' required />
              </div>
            </div>


{/* Email */}
            <div className='mb-4 col-md-4'>
              <div className='profile-input-area'>
                <label className='profile-badge'>Email Address</label>
                <input type='email' name='email' value={formData.email} onChange={handleChange} className='profile-input' />
              </div>
            </div>
                        {/* User ID */}
            <div className='mb-4 col-md-4'>
              <div className='profile-input-area'>
                <label className='profile-badge'>Registration Id*</label>
                <input type='text' name='user_id' value={formData.user_id} onChange={handleChange} className='profile-input' required disabled />
              </div>
            </div>

            {/* Password */}
            <div className='mb-4 col-md-4'>
              <div className='profile-input-area'>
                <label className='profile-badge'>Password*</label>
                <input type='text' name='pass' value={formData.pass} onChange={handleChange} className='profile-input' required />
              </div>
            </div>


                            <p className='fw-semibold border-bottom mb-5'><Bs2CircleFill /> Other Information</p>
                        
                        
                                    {/* DOB */}
                                    <div className='mb-4 col-md-4'>
                                      <div className='profile-input-area'>
                                        <label className='profile-badge'>Date of Birth</label>
                                        <input type='date' name='dob' value={formData.dob} onChange={handleChange} className='profile-input' />
                                      </div>
                                    </div>
                        
                        
                                    {/* Gender */}
                                    <div className='mb-4 col-md-4'>
                                      <div className='profile-input-area'>
                                        <label className='profile-badge'>Gender</label>
                                        <select name='gender' value={formData.gender} onChange={handleChange} className='profile-input'>
                                          <option value=''>Select Gender</option>
                                          <option value='Male'>Male</option>
                                          <option value='Female'>Female</option>
                                          <option value='Other'>Other</option>
                                        </select>
                                      </div>
                                    </div>
                        
                        
                                    {/* Blood Group */}
                                    <div className='mb-4 col-md-4'>
                                      <div className='profile-input-area'>
                                        <label className='profile-badge'>Blood Group</label>
                                        <input type='text' name='blood_grp' value={formData.blood_grp} onChange={handleChange} className='profile-input' />
                                      </div>
                                    </div>
                        
                        
                                    {/* Father */}
                                    <div className='mb-4 col-md-6'>
                                      <div className='profile-input-area'>
                                        <label className='profile-badge'>Father's Name</label>
                                        <input type='text' name='father' value={formData.father} onChange={handleChange} className='profile-input' />
                                      </div>
                                    </div>
                        
                                    {/* Mother */}
                                    <div className='mb-4 col-md-6'>
                                      <div className='profile-input-area'>
                                        <label className='profile-badge'>Mother's Name</label>
                                        <input type='text' name='mother' value={formData.mother} onChange={handleChange} className='profile-input' />
                                      </div>
                                    </div>
                        
                        
                                    {/* Address */}
                                    <div className='mb-4 mt-2 col-12'>
                                      <div className='profile-input-area'>
                                        <label className='profile-badge'>Address</label>
                                        <textarea name='address' value={formData.address} onChange={handleChange} className='profile-input' rows='3' />
                                      </div>
                                    </div>
                        
<div className='px-2'>
                {response2.message && <ResponseMsg2 message={response2.message} status={response2.status} />}</div>

                        <div className='col-12 text-center'>
            <button className='profile-btn2 me-2' onClick={() => navigate('/admin/all-employees')}>Go Back</button>
                            <button type='submit' className='profile-btn'><FaCheck /> Update</button>
                        </div>
                    </div>
                </form>

            </div>
        </section>
    );
};

export default EditEmployee;
